
import {Component, Vue, Prop} from "vue-property-decorator";
import EditUser from "@/components/users/EditUser.vue";
import EditUserRights from "@/components/users/EditUserRights.vue";
import {Getter} from "vuex-class";
import { canEditUserRights } from "@/services/rights";

@Component({
    components: {
        EditUser,
        EditUserRights,
    },
})export default class ListSelectOverlay extends Vue {
    @Prop({default: "users"})
    public type: string;

    @Prop({default: () => []})
    public selectedItems: any[];

    @Prop({default: null})
    public companyId: number;

    @Prop({})
    public selectAll: () => void;

    @Prop({})
    public cancel: () => void;

    @Prop({})
    public deleteItems: () => void;

    @Prop({})
    public createGroup: () => void;

    @Getter private currentUser: any;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    get onlyOneUser(): boolean {
      return this.selectedItems.length === 1;
    }

    get canEditCurrentUser(): boolean {
      return this.selectedItems[0].Contact && this.canDoInEnvCompany("UPDATE_CONTACTS");
    }

    get canEditCurrentUserRights(): boolean {
      const targetRole = this.selectedItems[0].ManagersRelations ? "MANAGERS" : "GUESTS";
      return canEditUserRights(this.currentUser, targetRole, this.selectedItems[0].id);
    }

    get canDeleteCurrentUser(): boolean {
      const targetRole = this.selectedItems[0].ManagersRelations ? "MANAGERS" : "GUESTS";
      if (!this.companyId) {
        return false;
      } else if (targetRole === "MANAGERS" && this.canDoInEnvCompany( "DELETE_SUBORDINATES")) {
        return this.currentUser.id !== this.selectedItems[0].id;
      } else if (targetRole === "GUESTS" && this.canDoInEnvCompany("DELETE_CONTACTS")) {
        return this.currentUser.id !== this.selectedItems[0].id;
      }
      return false;
    }
}
